import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { ConfirmationButton, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from "react";
import { useInternalValuationStore } from "libs/feature-valuation-review-v2/src/hooks/useInternalValuationStore";
import { Alert, AlertTitle } from "@material-ui/lab";
import { CustomTaskDialog } from "@roc/feature-general-tasks";

const useStyles = makeStyles(theme => ({
  container: {
    margin: '0px 0px 10px 10px'
  },
  item: {
    marginTop: '10px'
  }
}))
const InternalValuationPaymentContent = observer(({ store, loanId }) => {
  const classes = useStyles();
  const url = store.paymentUrl;

  const copyLink = () => {
    navigator.clipboard.writeText(url);
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'The link was copied to clipboard!',
    });
  }

  const handleConfirmSendEmail = () => {
    store.requestInternalValuationPayment(loanId);
  };

  return (
    <>
      {url ? <Grid container xs={12} justifyContent="flex-start" alignItems="flex-start" className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="h6">
            Link to the RealVal Program payment
          </Typography>
        </Grid>
        <Grid item container xs={12} direction="row" justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={10}>
            <TextField
              className={classes.item}
              variant="outlined"
              disabled
              label='Url'
              fullWidth
              value={url}
            />
          </Grid>
          <Grid item xs={2}>
            <Button variant="contained" color="primary" fullWidth onClick={() => copyLink()}>
              COPY LINK
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.item}>
          <Typography variant="h6">
            Or you can send an email to the borrower with the payment link
          </Typography>
        </Grid>
        <Grid item container xs={12} className={classes.item} justifyContent="center" alignItems="center">
          <Grid item xs={3}>
            <ConfirmationButton
              variant="contained"
              onClick={handleConfirmSendEmail}
              color="primary"
              testId="sendTamariskPaymentButton"
              confirmDialogProps={{
                title: 'Confirmation',
                body: 'Email will be sent out. Please confirm',
              }}
            >
              EMAIL TO BORROWER
            </ConfirmationButton>
          </Grid>
        </Grid>
      </Grid> :
        <Grid container xs={12} justifyContent="flex-start" alignItems="flex-start" className={classes.container}>
          <Alert severity="info" style={{ width: '100%' }}>
            The RealVal Program for this loan is already paid
          </Alert>
        </Grid>}
    </>
  )
})
export const InternalValuationPaymentLinkForm = observer(({ open, onClose, document }) => {
  const { internalValuationStore } = useInternalValuationStore()
  const taskId = document?.taskId;

  useEffect(() => {
    if (open && document?.loanId) {
      internalValuationStore.fetchPaymentLink(document?.loanId)
    }
  }, [open, document])

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="RealVal Program Payment"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={
            <InternalValuationPaymentContent store={internalValuationStore} loanId={document?.loanId} />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="RealVal Program Payment"
          maxWidth="md"
          handleClose={onClose}
          dialogContent={
            <InternalValuationPaymentContent store={internalValuationStore} loanId={document?.loanId} />
          }
        />
      )}
    </>
  )
})